var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"top","width":"240","trigger":"hover","content":"规格一般格式为：数字+单位*数字+单位...，数字+单位为最小单元，中间用*：等符号隔开。"}},[_c('i',{staticClass:"el-icon-question spec-icon",attrs:{"slot":"reference","size":"28"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }